/** Keep the Portal's remember/MFA contract outside the visual library. */
export function portalLoginCredentials({ email, password, remember }) {
  return { email: email.trim().toLowerCase(), password, remember, trustDevice: remember };
}

/** Adapt the library's anchors to SPA navigation without stealing native browser actions. */
export function sidebarDestination(event, origin) {
  if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return null;
  const anchor = event.target.closest?.("a[href]");
  if (!anchor || !event.currentTarget.contains(anchor) || anchor.hasAttribute("download") ||
      (anchor.target && anchor.target !== "_self")) return null;
  const url = new URL(anchor.href, origin);
  return url.origin === origin ? `${url.pathname}${url.search}${url.hash}` : null;
}
